export default __webpack_public_path__ + "static/media/applications-image-25.48c1faff.jpg";